<template>
  <div class="list-group-item">
    <div :class="'row pointer ' + (prescription.archived ? 'opacity-50' : '')"
         @click="selectPrescriptionId(prescription.id)">
      <div class="col-12 col-md-8">
        <span>
          {{prescription.drug.name}}
          {{prescription.drug.measure}}
          {{prescription.drug.measureUnit}}
        </span>

        <small class="text-muted" v-if="prescription.drug.manufacturer">
          {{prescription.drug.manufacturer.name}}
        </small>

        <small class="text-muted d-block">
          {{ prescription.quantity }}
          {{ declensionNumbers(prescription.quantity, prescription.drug.format.name) }};
          {{ prescription.times.map(time => time.name).join(', ') }};
          {{ prescription.methods.map(method => method.name).join(', ') }}
        </small>
      </div>

      <div class="col-12 col-md-3">
        <span class="text-dark mr-3">{{duration(prescription)}}</span>

        <small class="text-muted d-block">
          с {{formatDate(new Date(prescription.startDate), 'd.m.y')}}
          по {{formatDate(new Date(prescription.finishDate), 'd.m.y')}}
        </small>
      </div>

      <div class="col-12 col-md-1">
        <div v-if="prescription.startedAt" class="text-success">
          начат

          <small class="d-block text-nowrap">
            {{formatDate(new Date(prescription.startedAt), 'd.m.y')}}
          </small>
        </div>

        <div v-else class="text-warning">не начат</div>
      </div>
    </div>
  </div>
</template>

<script>
  import formatDate from '../../../utils/formatDate';
  import declensionNumbers from '../../../utils/declensionNumbers';
  import {MS_IN_DAY, FORMAT_NAMES} from '../../../constants';

  export default {
    name: 'ClientDrugItem',

    props: ['prescription'],

    methods: {
      selectPrescriptionId(id) {
        this.$emit('select-prescription-id', id);
      },

      duration(prescription) {
        const finishDate = new Date(prescription.finishDate);
        const startDate = new Date(prescription.startDate);
        const compareDate = new Date(finishDate.getTime() + MS_IN_DAY);

        if (startDate.getDate() === compareDate.getDate()) {
          const yearsDiff = (compareDate.getFullYear() - startDate.getFullYear());
          const duration = compareDate.getMonth() + (yearsDiff * 12) - startDate.getMonth();

          return duration + ' ' + declensionNumbers(duration, 'месяцев', 'месяц', 'месяца');
        }

        const durationInMs = compareDate.getTime() - startDate.getTime();
        const durationInDays = parseInt(durationInMs / MS_IN_DAY);

        if (durationInDays % 7 === 0 && durationInDays !== 0) {
          const durationInWeeks = durationInDays / 7;

          return durationInWeeks + ' ' + declensionNumbers(durationInWeeks, 'недель', 'неделя', 'недели');
        }

        return durationInDays + ' ' + declensionNumbers(durationInDays, 'дней', 'день', 'дня');
      },

      formatDate(date) {
        return formatDate(new Date(date), 'd.m.y');
      },

      declensionNumbers(count, name) {
        const formatName = FORMAT_NAMES.find(item => item[0] === name);
        const [, few, one, two ] = formatName || [name, name, name, name];

        return declensionNumbers(count, few, one, two);
      },
    },
  };
</script>
